import { classNames } from '@commenda/utils';
import { Icons } from '../../Icons';
import { RowSelectActionMenuProps } from '../types';

export function RowSelectActionMenu({
  renderActionMenu,
  selectedCount,
  isOpen,
  onClose,
}: RowSelectActionMenuProps) {
  return (
    <div
      className={classNames(
        'fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50 w-fit max-w-[calc(100vw-3rem)]',
        'bg-bg-solid shadow-lg rounded-2xl border border-border-primary',
        'transition-all duration-300 ease-in-out',
        'text-white',
        isOpen
          ? 'translate-y-0 opacity-100'
          : 'translate-y-[200%] opacity-0 pointer-events-none'
      )}
    >
      <div className="flex items-center gap-3 px-6 py-3">
        <div className="flex flex-wrap items-center gap-3">
          {renderActionMenu ? (
            renderActionMenu()
          ) : (
            <span className="txt-small-medium">
              {selectedCount} {selectedCount === 1 ? 'item' : 'items'} selected
            </span>
          )}
        </div>

        <Icons.XClose
          className="shrink-0 cursor-pointer size-4"
          onClick={onClose}
        />
      </div>
    </div>
  );
}
